import { gql } from '@apollo/client';

import {
  BRAND_TRANSLATIONS_FRAGMENT,
  FETCH_SINGLE_RULE_FRAGMENT,
  RETURN_INSTRUCTION_SET_FRAGMENT,
  RETURN_ONE_FRAGMENT,
  RETURN_REASON_SET_FRAGMENT,
} from './fragments';

export const RETURNS_GET_ONE_BY_ID_PRODUCTS = gql`
  query Returns_GetOneById_Products($input: IdInput!) {
    Returns_GetOne(input: $input) {
      courier {
        integration
        type
      }
      createdAt
      products {
        action
        sku
        exchangeData {
          originalId
          variantId
          quantity
        }
        attachments
        currency
        totalValue
        reason
        pictureUrl
        name
        variant
        details
        quantity
      }
      refundMethod
      returnMethod
      paymentDetails {
        shippingValue
        returnValue
        toBePaid
        toBeReturned
      }
      id
      status
    }
  }
`;

export const RETURNS_GET_MANUAL_APPROVE_BY_ID = gql`
  query Returns_GetManualApprove($returnId: ID!) {
    Returns_GetManualApprove(returnId: $returnId) {
      warehouse
      courier {
        courierId
        courierMethodId
        integration
        type
      }
      paymentDetails {
        toBeReturned
        returnValue
        shippingValue
        toBePaid
      }
      createdAt
      products {
        sku
        quantity
        totalValue
        order
        details
        attachments
        action
        ids
        manualApproved
        manualRejected
        name
        variant
        price
        currency
        pictureUrl
        discount
        discountPrice
        reason
      }
      returnProducts {
        manualApproveStatus
        _id
        currency
        details
        name
        pictureUrl
        price
        reason
        variant
        orderIdentifier
        attachments
      }
      refundMethod
      returnMethod
      manualApproveStatus
      exchangeProducts {
        id
        variantId
        title
        variantTitle
        imageUrl
        quantity
        originalTotalPrice
        originalUnitPrice
        discountedTotalPrice
        discountedUnitPrice
      }
    }
  }
`;
export const RETURNS_CALCULATE_REVENUE_ANALYTICS = gql`
  query Returns_CalculateRevenueAnalytics($from: String!, $to: String!) {
    Returns_CalculateRevenueAnalytics(from: $from, to: $to) {
      retainedRevenue
      additionalRevenue
      totalRevenue
      storeCredits
    }
  }
`;

export const REASONS_SETS = gql`
  query ReasonsSetsQuery {
    ReturnReasonSet_GetAll {
      ...ReturnReasonSet
    }
  }
  ${RETURN_REASON_SET_FRAGMENT}
`;

export const FETCH_RETURN_INSTRUCTION_SET_GETALL = gql(/* GraphQL */ `
  query ReturnInstructionSet_GetAll {
    ReturnInstructionSet_GetAll {
      name
      id
    }
  }
`);

export const INSTRUCTIONS_SETS = gql`
  query InstructionsSetsQuery {
    ReturnInstructionSet_GetAll {
      ...ReturnInstructionSet
    }
  }
  ${RETURN_INSTRUCTION_SET_FRAGMENT}
`;

export const BRAND_TRANSLATIONS_QUERY = gql`
  query BrandTranslationsQuery($id: String!) {
    translation(brandId: $id) {
      ...BrandTranslations
    }
  }
  ${BRAND_TRANSLATIONS_FRAGMENT}
`;

export const FETCH_QUESTIONS_ANSWERS = gql(`
  query QuestionsAndAnswers_findByBrand($brandId: String!) {
    items: QuestionsAndAnswers_findByBrand(brandId: $brandId) {
      id
      entries {
        language
        question
        answer
      }
    }
  }
`);

export const FETCH_RULES_QUERY = gql(`
  query FetchRulesQuery {
    ReturnRules_Find {
      count
      rules {
        id
        name
        condition {
          logOp
          conditions {
            logOp
            conditions {
              op
              param
              type
              value
            }
            op
            param
            type
            value
          }
        }
        isDraft
        isActive
      }
    }
  }
`);

export const FETCH_SINGLE_RULE_QUERY = gql`
  query FetchSingleRuleQuery($input: IdInput!) {
    ReturnRules_FindOne(input: $input) {
      ...FetchSingleRuleQueryFragment
    }
  }
  ${FETCH_SINGLE_RULE_FRAGMENT}
`;

export const RETURN_ONE = gql`
  query Returns_GetOneById($input: IdInput!) {
    Returns_GetOne(input: $input) {
      ...ReturnOneFragment
    }
  }
  ${RETURN_ONE_FRAGMENT}
`;

export const RETURN_QUERY = gql`
  query Returns_GetClientInfoById($input: ReturnsGetClientInfoByIdInput!) {
    Returns_GetClientInfoById(input: $input) {
      clientInfo {
        address
        city
        company
        countryCode
        email
        name
        phone
        postcode
        state
      }
    }
  }
`;
